// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2WOkz","title":"styles_title__3uX2p"};